module.exports = __webpack_public_path__ + "static/media/C.135f9c6c.jpg";